"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusDot = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const dot_styles_1 = require("@/components/common/dot/dot.styles");
const utils_1 = require("@/utils");
const statusDotToneMap = {
    live: 'red',
    online: 'green',
    new: 'gold',
    unread: 'blue',
};
/** variant가 곧 의미이므로 읽히는 이름도 함께 갖는다. */
const statusDotLabels = {
    live: '실시간',
    online: '접속 중',
    new: '새 항목',
    unread: '읽지 않음',
};
const variantTokens = Object.fromEntries(Object.entries(statusDotToneMap).map(([variant, tone]) => [variant, (0, dot_styles_1.dotToneTokens)(tone)]));
/**
 * 색 하나로 상태를 말하는 점. 자기가 의미를 가지므로 role과 읽히는 이름을 스스로 갖는다.
 */
let StatusDot = class StatusDot extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'online';
        this.ariaLabel = '';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'img');
    }
    willUpdate() {
        if (this.ariaLabel)
            return;
        this.ariaLabel = statusDotLabels[this.variant];
    }
};
StatusDot.styles = (0, lit_1.css) `
    :host {
      ${dot_styles_1.dotStyles}
    }

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('variant', variantTokens))}
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true, useDefault: true })
], StatusDot.prototype, "variant", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label', reflect: true })
], StatusDot.prototype, "ariaLabel", void 0);
StatusDot = __decorate([
    (0, decorators_js_1.customElement)('mm-status-dot')
], StatusDot);
exports.StatusDot = StatusDot;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdHVzLWRvdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInN0YXR1cy1kb3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQWdEO0FBQ2hELHFEQUEyRDtBQUUzRCxtRUFBNkU7QUFFN0UsbUNBQTZDO0FBRTdDLE1BQU0sZ0JBQWdCLEdBQUc7SUFDdkIsSUFBSSxFQUFFLEtBQUs7SUFDWCxNQUFNLEVBQUUsT0FBTztJQUNmLEdBQUcsRUFBRSxNQUFNO0lBQ1gsTUFBTSxFQUFFLE1BQU07Q0FDNEIsQ0FBQTtBQUk1Qyx1Q0FBdUM7QUFDdkMsTUFBTSxlQUFlLEdBQXFDO0lBQ3hELElBQUksRUFBRSxLQUFLO0lBQ1gsTUFBTSxFQUFFLE1BQU07SUFDZCxHQUFHLEVBQUUsTUFBTTtJQUNYLE1BQU0sRUFBRSxPQUFPO0NBQ2hCLENBQUE7QUFFRCxNQUFNLGFBQWEsR0FBRyxNQUFNLENBQUMsV0FBVyxDQUN0QyxNQUFNLENBQUMsT0FBTyxDQUFDLGdCQUFnQixDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxPQUFPLEVBQUUsSUFBSSxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUMsT0FBTyxFQUFFLElBQUEsMEJBQWEsRUFBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQzFGLENBQUE7QUFFRDs7R0FFRztBQUVJLElBQU0sU0FBUyxHQUFmLE1BQU0sU0FBVSxTQUFRLGdCQUFVO0lBQWxDOztRQVF3RCxZQUFPLEdBQXFCLFFBQVEsQ0FBQTtRQUM3QixjQUFTLEdBQUcsRUFBRSxDQUFBO0lBWXBGLENBQUM7SUFWQyxpQkFBaUI7UUFDZixLQUFLLENBQUMsaUJBQWlCLEVBQUUsQ0FBQTtRQUN6QixJQUFJLENBQUMsWUFBWSxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQTtJQUNsQyxDQUFDO0lBRUQsVUFBVTtRQUNSLElBQUksSUFBSSxDQUFDLFNBQVM7WUFBRSxPQUFNO1FBRTFCLElBQUksQ0FBQyxTQUFTLEdBQUcsZUFBZSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQTtJQUNoRCxDQUFDOztBQW5CTSxnQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOztRQUViLHNCQUFTOzs7TUFHWCxJQUFBLGVBQVMsRUFBQyxJQUFBLDJCQUFtQixFQUFDLFNBQVMsRUFBRSxhQUFhLENBQUMsQ0FBQztHQUMzRCxDQUFBO0FBQzREO0lBQTVELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxVQUFVLEVBQUUsSUFBSSxFQUFFLENBQUM7MENBQXFDO0FBQzdCO0lBQW5FLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLFlBQVksRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7NENBQWU7QUFUdkUsU0FBUztJQURyQixJQUFBLDZCQUFhLEVBQUMsZUFBZSxDQUFDO0dBQ2xCLFNBQVMsQ0FxQnJCO0FBckJZLDhCQUFTIn0=